import { useEffect, useRef, useState } from 'react';
import { buttonClass } from './AdmissionFields';
export default function PhotoCrop({
  file,
  onSave,
  onCancel
}) {
  const canvas = useRef(null),
    image = useRef(null);
  const [ready, setReady] = useState(false),
    [error, setError] = useState(''),
    [zoom, setZoom] = useState(1),
    [x, setX] = useState(0),
    [y, setY] = useState(0);
  useEffect(() => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    setReady(false);
    setError('');
    setZoom(1);
    setX(0);
    setY(0);
    img.onload = () => {
      image.current = img;
      setReady(true);
    };
    img.onerror = () => setError('This image could not be opened. Choose a JPEG, PNG or WebP photo.');
    img.src = url;
    return () => {
      img.onload = null;
      img.onerror = null;
      URL.revokeObjectURL(url);
    };
  }, [file]);
  useEffect(() => {
    if (!ready || !canvas.current) return;
    const img = image.current;
    const w = Math.min(img.width, img.height * 0.75) / zoom;
    const h = w / 0.75;
    const left = (img.width - w) * (x + 100) / 200,
      top = (img.height - h) * (y + 100) / 200;
    canvas.current.getContext('2d').drawImage(img, left, top, w, h, 0, 0, 600, 800);
  }, [ready, zoom, x, y]);
  return <div className="space-y-3 rounded-xl border bg-[#f5f7f5] p-4"><h3 className="font-semibold">Preview and crop photo</h3>{error && <p role="alert">{error}</p>}<canvas ref={canvas} width="600" height="800" className="mx-auto w-48 max-w-full rounded-lg bg-white" aria-label="Cropped photo preview" />{[['Zoom', zoom, setZoom, 1, 3, 0.05], ['Horizontal position', x, setX, -100, 100, 1], ['Vertical position', y, setY, -100, 100, 1]].map(([title, value, set, min, max, step]) => <label className="block text-sm" key={title}>{title}<input className="block w-full" type="range" min={min} max={max} step={step} value={value} onChange={e => set(Number(e.target.value))} /></label>)}<div className="flex gap-3"><button type="button" disabled={!ready} className={buttonClass} onClick={() => canvas.current.toBlob(blob => {
        if (blob) onSave(new File([blob], 'student-photo.jpg', {
          type: 'image/jpeg'
        }));
      }, 'image/jpeg', 0.9)}>Use this photo</button><button type="button" onClick={onCancel}>Cancel</button></div></div>;
}
